<template>
  <div class="min-h-screen bg-gray-50 px-4 pt-6 pb-28" dir="rtl">
    <div class="max-w-4xl mx-auto md:max-w-lg space-y-4">
      
      <!-- Add Product Button (if editable) -->
      <button 
        v-if="editable==1"
        class="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 px-6 rounded-lg font-semibold transition-all duration-200"
        @click="dialog_model=true"
      >
        {{ $t('addNewProduct') }}
      </button>

      <!-- Products List -->
      <div class="space-y-3" v-if="list.length > 0">
        <div 
          v-for="(item, index) in list" 
          :key="item.Id || index"
          class="bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md hover:border-blue-300 transition-all duration-200"
        >
          <div class="flex items-start gap-3">
            <!-- Product Info -->
            <div class="flex-1 min-w-0">
              <h3 class="text-sm font-bold text-gray-900 leading-6 mb-3">{{ item.ProductName }}</h3>
              
              <div class="grid grid-cols-2 gap-2">
                <!-- Quantity -->
                <div class="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2">
                  <svg class="w-4 h-4 flex-shrink-0 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  </svg>
                  <span class="text-xs font-semibold text-gray-700 truncate">{{ item.Qty }} {{ $t('numbers') }}</span>
                </div>
                
                <!-- Price -->
                <div class="flex items-center gap-2 bg-blue-50 rounded-lg px-3 py-2">
                  <svg class="w-4 h-4 flex-shrink-0 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span class="text-xs font-bold text-blue-600 truncate">{{ get_currency(item.UnitPrice) }} <span class="font-normal">تومان</span></span>
                </div>
              </div>

              <p v-if="item.Summary" class="mt-3 text-xs text-gray-500 leading-5 whitespace-pre-wrap">{{ item.Summary }}</p>
            </div>
            
            <!-- Delete Icon (if editable) -->
            <button
              v-if="editable==1"
              type="button"
              class="flex-shrink-0 self-start w-9 h-9 inline-flex items-center justify-center rounded-lg bg-red-50 hover:bg-red-100 text-red-600 transition-colors"
              @click.stop="delete_dialog(item, index)"
              title="حذف"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else class="bg-white rounded-xl border border-dashed border-gray-300 p-12 text-center">
        <div class="max-w-2xl mx-auto">
          <div class="w-20 h-20 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
            <svg class="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          </div>
          <p class="text-gray-500 font-medium mb-2">محصولی اضافه نشده است</p>
          <p class="text-sm text-gray-400" v-if="editable==1">برای اضافه کردن محصول روی دکمه بالا کلیک کنید</p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-3">
        <button 
          v-if="master_id==0 && list.length"
          class="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 px-6 rounded-lg font-semibold transition-all duration-200"
          @click="add_factor()"
        >
          ثبت فاکتور
        </button>

        <button 
          v-if="editable==1 && master_id!=0"
          class="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white py-4 px-6 rounded-lg font-semibold transition-all duration-200"
          @click="add_factor_final()"
        >
          نهایی کردن فاکتور
        </button>

        <div v-if="editable==0 && master_id!=0">
          <InformherAttachments :doc_type="$route.params.doc_type" :master_id="master_id"/>
        </div>
      </div>

    </div>

    <!-- Add Product Modal -->
    <div v-if="dialog_model" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center">
      <div class="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-90vh overflow-hidden flex flex-col">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-200">
          <h2 class="text-lg font-bold text-gray-900">{{ $t('addProduct') }}</h2>
        </div>

        <!-- Body -->
        <div class="px-6 py-4 overflow-y-auto min-h-300px flex-1">
          <!-- Product Search -->
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('searchProduct') }}</label>
            <treeselect
              :multiple="false"
              :load-options="load_models"
              :normalizer="normalizer_models"
              :async="true"
              :placeholder="$t('searchProduct')"
              v-model="auto_complete_model"
            />
          </div>

          <!-- Qty and Price -->
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('count') }}</label>
              <input 
                type="number" 
                inputmode="numeric"
                v-model="product_count" 
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                :placeholder="$t('count')"
                style="border: 1px solid #d1d5db !important;"
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">قیمت <span class="text-10px text-red-500">(تومان)</span></label>
              <input 
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                v-model="product_price" 
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="مثلاً 1,000,000"
                style="border: 1px solid #d1d5db !important;"
              />
            </div>
          </div>

          <!-- Description -->
          <div class="mt-4">
            <label class="block text-sm font-medium text-gray-700 mb-2">توضیحات</label>
            <textarea
              v-model="product_summary"
              rows="3"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="توضیحات"
              style="border: 1px solid #d1d5db !important;"
            ></textarea>
          </div>
        </div>

        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button 
            class="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
            @click="dialog_model = false"
          >
            {{ $t('cancel') }}
          </button>
          <button 
            class="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-lg transition-all duration-200"
            @click="add_model_to_list()"
          >
            {{ $t('ok') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div v-if="delete_dialog_modal" class="fixed inset-0 bg-black bg-opacity-50 z-999 flex items-center justify-center">
      <div class="bg-white rounded-lg shadow-xl w-full max-w-sm mx-4">
        <!-- Header -->
        <div class="px-6 py-4 border-b border-gray-200">
          <h2 class="text-lg font-bold text-gray-900">{{ $t('deleteProduct') }}</h2>
        </div>

        <!-- Body -->
        <div class="px-6 py-4">
          <p class="text-gray-700">{{ $t('sureToDeleteProduct') }}</p>
        </div>

        <!-- Footer -->
        <div class="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button 
            class="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200"
            @click="delete_dialog_modal = false"
          >
            {{ $t('no') }}
          </button>
          <button 
            class="px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-medium rounded-lg transition-all duration-200"
            @click="delete_detail_item()"
          >
            {{ $t('yes') }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import axios from 'axios'
import Vue from 'vue'
import { bus } from '../../../main'
import InformherAttachments from "./InformherAttachments.vue"

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}

export default {
  props: [
    'passing_data'
  ],
  data() {
    return {
      editable: 0,
      master_id: 0,
      auto_complete_model: null,
      search_entries: [],
      model_txt: '',
      delete_dialog_modal: false,
      status_form: 0,
      dialog_model: false,
      product_count: '',
      product_price: '',
      product_summary: '',
      product_items: [],
      branch_id: 0,
      list: [],
      errors: [],
      selected_post: 0,
      selected_branch: 0,
      show_loading: false,
      no_info: true,
      page: 0,
      normalizer_models(node) {
        return {
          id: node.ProductId,
          label: node.ProductName,
        }
      },
      first: true,
    }
  },
  computed: {},
  components: {
    Treeselect,
    InformherAttachments
  },
  watch: {
    auto_complete_model() {
      for (var i = 0; i < this.search_entries.length; i++) {
        if (this.search_entries[i].ProductId == this.auto_complete_model) {
          this.model_txt = this.search_entries[i].ProductName
        }
      }
    },
    product_price() {
      const formatted = this.formatAmountInput(this.product_price)
      if (this.product_price !== formatted) {
        this.product_price = formatted
      }
    }
  },
  mounted() {
    this.editable = this.$route.params.editable;
    this.master_id = this.$route.params.master_id;

    if (this.master_id != 0) {
      this.get_factors()
    }
    this.get_branch_permission()

    this.selected_post = parseInt(localStorage.getItem('selected_post'))
  },

  methods: {
    delete_dialog(item, index) {
      if (this.editable == 1) {
        this.delete_dialog_modal = true
        this.status_form = this.master_id == 0 ? index : item.Id
      }
    },
    load_models({ action, searchQuery, callback }) {
      this.model_txt = searchQuery
      this.auto_complete_model = null
      var self = this
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options

          var passing_data = JSON.parse(localStorage.getItem('request_data'))
          var url = {}
          var send_data = {}
          if (self.$route.params.doc_type == '156') {
            send_data = {
              CostCenterId: self.$route.params.rec_id,
              Searchtxt: searchQuery,
            }
            url = "/GetBatchItems"
          } else {
            send_data = {
              MainProductId: 0,
              TxtSearch: searchQuery,
            }
            url = "/GetProductLowInfosByKeword"
          }

          this.axios.post(url, send_data, {show_pros: false},)
            .then(response => {
              if (self.$route.params.doc_type == '156') {
                self.search_entries = response.data.vmList
                options = response.data.vmList
              } else {
                self.search_entries = response.data.products
                options = response.data.products
              }
              callback(null, options)
            }).catch(e => {
              this.errors.push(e)
            })
        })
      }
    },

    add_model_to_list() {
      if (this.auto_complete_model != null && this.product_count != 0 && this.product_count != '' && this.parseAmountInput(this.product_price) !== '') {
        this.list.push({
          ProductId: this.auto_complete_model,
          Qty: this.product_count,
          UnitPrice: this.parseAmountInput(this.product_price),
          ProductName: this.model_txt,
          Summary: this.product_summary
        })
        this.dialog_model = false
        this.auto_complete_model = null
        this.product_count = ''
        this.product_price = ''
        this.product_summary = ''
        if (this.master_id != 0) {
          this.add_factor_detail(this.list.length - 1)
        }
      }
    },
    get_factors() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        MasterId: this.master_id,
      }

      console.log('pre request called')
      this.axios.post('/GetCustomerDetailFacts', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            self.list = response.data.items
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
    get_branch_permission() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      var party_id = localStorage.getItem('party_id')

      const send_data = {
        UserId: user_id,
        Role: 'BranchDefinition',
        PartyId: party_id,
      }
      this.axios.post('/ZkGetUserPermission', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            this.branch_id = response.data.UserBranchId
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },

    add_factor() {
      if (this.list.length == 0) {
        bus.$emit('show_toast', [1500, "حداقل یک کالا انتخاب کنید"])
        return
      }
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        RequestId: this.$route.params.rec_id,
        ReqName: "",
        UserId: user_id,
        BranchId: localStorage.getItem("branch_id"),
        DocNo: this.$route.params.doc_type,
        DocDate: "",
        DocDescription: "",
      }

      console.log('pre request called')
      this.axios.post('/AddMasterFactor', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            self.master_id = response.data.MasterId
            self.add_factor_detail(0)
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
    go_to_attachments() {
      this.$router.push({ path: '/report-request/informher-attachments/' + this.$route.params.rec_id + '/' + this.master_id + '/' + this.$route.params.doc_type })
    },
    add_factor_final() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        RequestId: this.$route.params.rec_id,
        UserId: user_id,
        DocType: this.$route.params.doc_type,
        MasterId: this.master_id,
      }
      this.axios.post('/AddFactorToFinal', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            self.master_id = response.data.MasterId
            bus.$emit('show_toast', [1500, response.data.msg])
            self.editable = 0
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
    add_factor_detail(index) {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        MasterId: this.master_id,
        RequestId: this.$route.params.rec_id,
        Qty: this.list[index].Qty,
        Summary: this.list[index].Summary || "",
        UnitPrice: this.list[index].UnitPrice,
        TotalPrice: this.list[index].Qty * this.list[index].UnitPrice,
        ProductId: this.list[index].ProductId,
        UserId: user_id,
      }
      console.log('pre request called')
      this.axios.post('/AddDetailFactor', send_data, {})
        .then(response => {
          self.last_request_items = []
          if (response.data.error == 0) {
            if (index < self.list.length - 1) {
              self.add_factor_detail(index + 1)
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
              self.get_factors()
            }
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
    delete_factor_detail() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId

      const send_data = {
        MasterId: this.master_id,
        RecId: this.status_form,
        UserId: user_id,
      }
      this.status_form = 0;

      this.axios.post('/DeleteDetailFactor', send_data, {})
        .then(response => {
          if (response.data.error == 0) {
            self.get_factors();
          } else {
            bus.$emit('show_toast', [1500, response.data.msg])
          }
        }).catch(e => {
          this.errors.push(e)
        })
    },
    delete_detail_item() {
      this.delete_dialog_modal = false
      if (this.master_id == 0) {
        this.list.splice(this.status_form, 1)
        this.status_form = 0;
      } else {
        this.delete_factor_detail();
      }
    },

  }
}
</script>

<style scoped>
/* Custom styles for Treeselect */
.vue-treeselect__control {
  border-color: #d1d5db !important;
  border-radius: 0.5rem !important;
}

.vue-treeselect__control:hover {
  border-color: #3b82f6 !important;
}

.vue-treeselect__control:focus {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2) !important;
}

/* Ensure inputs have proper styling */
input,
textarea {
  border: 1px solid #d1d5db !important;
  border-radius: 0.5rem !important;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2) !important;
}
</style>
